module.exports = __webpack_public_path__ + "static/media/rfox-bnb.dbb90f94.svg";